export const DEAL_PAYROLL_GROUP_REPORT_PATH = '/payroll-report';
export const DEAL_PAYROLL_BREAKDOWN_PATH = '/report/deal-payroll-breakdown';
export const DEAL_PAYROLL_MONTH_PARAM = 'month';
export const DEAL_PAYROLL_REFRESH_PARAM = 'refresh';
export const DEAL_PAYROLL_PROGRESS_HEADER = 'report-progress-id';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/deal-payroll.service.constants.ts